import type { DriftHistoryPoint } from "../../../api/frameworksApi";

/**
 * Normalizes any raw detail or check status into a uniform verdict:
 * 'passed' | 'failed' | 'not_applicable'
 */
export function normalizeDriftDetailStatus(
  rawStatus?: string,
): "passed" | "failed" | "not_applicable" {
  if (!rawStatus) return "failed";
  const s = rawStatus
    .toLowerCase()
    .trim()
    .replace(/[\s\-_/]+/g, "");
  if (s === "notapplicable" || s === "na" || s === "notappliable") {
    return "not_applicable";
  }
  if (s === "passed" || s === "pass" || s === "satisfied") {
    return "passed";
  }
  return "failed";
}

/**
 * Derives scan count totals (passed, failed, unknown, total) from an array of history points.
 */
export function deriveScanCountsFromHistory(
  history: DriftHistoryPoint[],
): {
  totalScans: number;
  passedScans: number;
  failedScans: number;
  unknownScans: number;
} {
  let passedScans = 0;
  let failedScans = 0;
  let unknownScans = 0;
  for (const h of history) {
    const s = (h.status ?? "")
      .toLowerCase()
      .trim()
      .replace(/[\s-]+/g, "_");
    if (
      s === "passed" ||
      s === "satisfied" ||
      s === "pass" ||
      s === "not_applicable" ||
      s === "notapplicable" ||
      s === "na" ||
      s === "not_appliable"
    ) {
      passedScans++;
    } else if (
      s === "failed" ||
      s === "fail" ||
      s === "not_satisfied" ||
      s === "notsatisfied" ||
      s === "not_passed" ||
      s === "unsatisfied" ||
      s === "non_compliant"
    ) {
      failedScans++;
    } else {
      unknownScans++;
    }
  }
  return { totalScans: history.length, passedScans, failedScans, unknownScans };
}
